import { useState, useEffect, useRef } from "react";

import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Portfolio from "./components/Portfolio/Portfolio";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Techstack from "./components/Techstack/Techstack";
import Common from "./components/common/Common";
import Reveal from "./components/common/Reveal";
import LoaderSimple from "./components/LoaderPage/LoaderPage";

function App() {
  const [loading, setLoading] = useState(true);





  return (
    <>
      {loading && <LoaderSimple setLoading={setLoading} />}
      <div className="">
        {!loading && (
          <main className="h-full w-full items-center px-5 custom-gradient text-white">
            <Header />
            <Hero />
            <Reveal>
              <Techstack />
            </Reveal>
            <Reveal>
              <div>
                <Common
                  title="My Techstack 🧰"
                  subtitle="These are the tools and technologies I use to build modern, fast, and reliable web applications."
                >
                  <img
                    src="https://shipfa.st/_next/static/media/demo.753bdb0f.png"
                    alt="Contact Info"
                    className="md:w-1/2 md:h-1/2 w-full h-full rounded-2xl p-2"
                  />
                </Common>
              </div>
            </Reveal>
            <Portfolio />
            <Reveal>
              <Contact />
            </Reveal>
            <Reveal>
              <Footer />
            </Reveal>
          </main>
        )}
      </div>
    </>
  );
}

export default App;
